import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import { lighten, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const PREFIX = 'CircularProgressWithLabel';

const classes = {
  bufferCircle: `${PREFIX}-bufferCircle`,
};

const StyledBox = styled(Box)((
  {
    theme,
  },
) => ({
  [`& .${classes.bufferCircle}`]: {
    '& svg.MuiCircularProgress-svg': {
      color: `${lighten(theme.palette.primary.main, 0.8)} !important`,
    },
  },
}));

const CircularProgressWithLabel = (props: CircularProgressProps & { value: number, buffer?: number }) => {
  const { value, buffer } = props;
  return (
    <StyledBox
      sx={{
        position: 'relative',
        display: 'inline-flex',
      }}
    >
      <Box
        sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
      }}
      >
        <CircularProgress variant="determinate" {...props} color="secondary" value={100} />
      </Box>
      <Box
        sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
      }}
      >
        <CircularProgress className={classes.bufferCircle} variant="determinate" {...props} value={buffer || 0} />
      </Box>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        <Typography variant="caption" component="span" color="textSecondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </StyledBox>
  );
};

export default CircularProgressWithLabel;
